import React from "react";
import styles from "./ConfirmDialog.module.css";

type Props = {
    title: string;
    subtitle: string;
    panelTitle: string;
    description: React.ReactNode;
    confirmLabel: string;
    cancelLabel: string;
    onConfirm: () => void;
    onCancel: () => void;
};

export default function ConfirmDialog({ title, subtitle, panelTitle, description, confirmLabel, cancelLabel, onConfirm, onCancel }: Props) {
    return (
        <section className={styles["decision-card"]}>
            <h2 className={styles["decision-card__title"]}>{title}</h2>
            <p className={styles["decision-card__subtitle"]}>{subtitle}</p>

            <div className={styles["decision-card__panel"]}>
                <div className={styles["decision-card__panelTitle"]}>{panelTitle}</div>
                <div className={styles["decision-card__desc"]}>{description}</div>
                <div className={styles["decision-card__actions"]}>
                    <button className={styles["decision-card__btn"]} onClick={onConfirm}>
                        {confirmLabel}
                    </button>
                    <button className={styles["decision-card__btn"]} onClick={onCancel}>
                        {cancelLabel}
                    </button>
                </div>
            </div>
        </section>
    );
}
